import { getPresetRange } from '@app/components/date-range-selector/date-range/date-range-presets';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { useMemo } from 'react';
import { StreamQualityReportValues } from './types';

/**
 * Default form values: last 24 hours (user timezone) and empty advanced station filter (all stations on the API).
 */
export function useStreamQualityReportDefaultValues(): StreamQualityReportValues {
  const tz = useTimezone();

  return useMemo(() => {
    const preset = 'last24Hours';
    const range = getPresetRange(preset, tz);

    if (!range) {
      throw new Error('Expected preset range for "last24Hours"');
    }

    return {
      dateRange: {
        from: range.from.toISOString(),
        to: range.to.toISOString(),
        preset,
      },
      stationsFilter: [],
    };
  }, [tz]);
}
